<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        :title="title"
        :height="height"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/PickPlaceSheet/CorePickPlaceSheetDetail"
        :parent-component="$options.name"
        :main-validator="mainValidator"
        :row-background="rowBackground"
        @embedded_action="$emit('embedded_action', $event)"
    >
      <template v-slot:item.bom_sheet__component__article="{ item }">
        {{ component_property(item, 'article_display') }}
      </template>
      <template v-slot:item.bom_sheet__component__alias="{ item }">
        <v-chip
            v-if="component_property(item, 'alias')"
            @click="detailStoreComponent.openDetailDialog(
                {item: null, uid: storeAggregate.rootData[item.bom_sheet_uid].component_uid})"
        >
          {{ component_property(item, 'alias') }}
        </v-chip>
      </template>
      <template v-slot:item.bom_sheet__component__case_package__type="{ item }">
        <v-chip
            v-if="!!item.bom_sheet_uid && storeAggregate.rootData &&
            !!storeAggregate.rootData[item.bom_sheet_uid].component_uid &&
            !!storeAggregate.rootData[storeAggregate.rootData[item.bom_sheet_uid].component_uid] &&
            !!storeAggregate.rootData[storeAggregate.rootData[item.bom_sheet_uid].component_uid].case_package_uid &&
            !!storeAggregate.rootData[storeAggregate.rootData[storeAggregate.rootData[item.bom_sheet_uid].component_uid].case_package_uid]"
            :color="storeAggregate.rootData[storeAggregate.rootData[storeAggregate.rootData[item.bom_sheet_uid].component_uid].case_package_uid].case_package_type_color_dict.color"
        >
          {{
            storeAggregate.rootData[storeAggregate.rootData[storeAggregate.rootData[item.bom_sheet_uid].component_uid].case_package_uid].case_package_type_color_dict.text
          }}
        </v-chip>
      </template>
      <template v-slot:item.bom_sheet__component__image="{ item }">
        <BaseImageCard
            v-if="!!component_property(item, 'image')"
            :value="component_property(item, 'image')"
            :max-height="40"
            :max-width="64"
            readonly
        >
        </BaseImageCard>
      </template>
      <template v-slot:item.bom_sheet__do_not_place="{ item }">
        <v-checkbox
            v-if="!!storeAggregate && !!item.bom_sheet_uid && storeAggregate.rootData &&
            !!storeAggregate.rootData[item.bom_sheet_uid]"
            v-model=storeAggregate.rootData[item.bom_sheet_uid].do_not_place
            readonly
            dense
            hide-details>
        </v-checkbox>
        {{''}}
      </template>
    </CommonTable>
    <v-dialog
        v-if="!!detailStoreComponent"
      ref="detailComponentDialog"
      v-model="detailStoreComponent.dialogDetail"
      persistent
      scrollable
  >
    <ComponentDetail
        :uid-item="detailStoreComponent.uidItem"
        :store-name="detailStoreComponentName"
        :modalDialog="true"
        :route-full-screen="{name: 'ComponentDetail', params: {itemUid: detailStoreComponent.uidItem}}"
        :main-validator="true"
        :embedded="embedded"
    ></ComponentDetail>
  </v-dialog>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CorePickPlaceSheetDetail from "@/components/CoreComponent/PickPlaceSheet/CorePickPlaceSheetDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import CommonFieldText from "@/components/Common/CommonFieldText";
import BaseImageCard from "@/components/Base/BaseImageCard";
import ComponentDetail from "@/components/CoreComponent/Component/ComponentDetail";
import {useDetailStore} from "@/components/Common/CommonDetail";

export default {
  name: "CorePickPlaceSheetTable",

  props: {
    height: {default: null},
    title: {default: 'PickPlaceSheet'},
    embedded: {default: false},
    headers: {default: null},
    storeName: {type: [String], default: 'CorePickPlaceSheetTable'},
    dtoDetailQuery: {default: 'PickPlaceSheetDetailQueryDTO'},
    detailStoreName: {default: 'PickPlaceSheetDetail'},
    dtoValidateCommand: {type: [String], default: 'PickPlaceSheetValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'PickPlaceSheetListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'PickPlaceSheetActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
    rowBackground: {default: null},
  },

  components: {
    ComponentDetail,
    CommonTable,
    CorePickPlaceSheetDetail,
    BaseFieldCheck,
    CommonFieldText,
    BaseImageCard,
  },

  methods: {
    component_property(item, property_name) {
      if (!!item.bom_sheet_uid && this.storeAggregate.rootData &&
            !!this.storeAggregate.rootData[item.bom_sheet_uid].component_uid &&
            !!this.storeAggregate.rootData[this.storeAggregate.rootData[item.bom_sheet_uid].component_uid])
        return this.storeAggregate.rootData[this.storeAggregate.rootData[item.bom_sheet_uid].component_uid][property_name]
      return null
    },
  },

  mounted() {
    this.storeAggregate = useAggregateStore()
    this.detailStoreComponent = useDetailStore(this.detailStoreComponentName)()
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = this.headers || [
      {text: 'Task', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 10},
      {
        text: 'Status',
        value: 'row_statuses',
        sortable: false,
        filterable: true,
        divider: true,
        align: 'center',
        width: 10,
        type: 'status'
      },
      {text: 'Edit', value: 'edit', sortable: false, filterable: true, divider: true, width: 10},
      // {text: 'bom_sheet_uid', value: 'bom_sheet_uid', sortable: false, filterable: true, divider: true, width: 100},
      {text: 'Designator', value: 'designator', sortable: true, align: 'left', divider: true, width: 100},
      {text: 'Original description', value: 'original_description', sortable: false, divider: true, width: 200},

      {text: 'Article', value: 'bom_sheet__component__article', sortable: false, align: 'right', divider: true, width: 50},
      {text: 'Alias', value: 'bom_sheet__component__alias', sortable: false, align: 'right', divider: true, width: 250},
      {text: 'CasePackage', value: 'bom_sheet__component__case_package__type', sortable: false, align: 'center', divider: true, width: 80},
      {text: 'Do not place', value: 'bom_sheet__do_not_place', sortable: false, filterable: true, divider: true, type: 'bool', width: 10},

      {text: 'Layer', value: 'layer', sortable: false, align: 'center', filterable: true, divider: true, width: 60},
      {text: 'Center X', value: 'center_x', sortable: false, align: 'center', filterable: true, divider: true, width: 60},
      {text: 'Center Y', value: 'center_y', sortable: false, align: 'center', filterable: true, divider: true, width: 60},
      {text: 'Rotation', value: 'rotation', sortable: false, align: 'center', filterable: true, divider: true, width: 60},
      {text: 'Customer article', value: 'customer_article', sortable: false, align: 'left', filterable: true, divider: true, width: 100},
      {text: 'Saved', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 10},
    ]
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
    }
  },

  data() {
    return {
      storeTable: null,
      detailStoreComponent: null,
      detailStoreComponentName: uuidv4(),
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>